import React from 'react';
import {Field, reduxForm} from "redux-form";
import TextField from "@material-ui/core/TextField";
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import {theme} from "../../Dashboard/theme";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import CssBaseline from '@material-ui/core/CssBaseline';
import styles from "../../Signup/SignupStyles";
import Avatar from "@material-ui/core/Avatar";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from '@material-ui/core/FormHelperText'
import {Link as RouterLink} from 'react-router-dom'
import MUIDataTable from "mui-datatables";

let themeCustom = {
  ...theme,
  overrides: {
    MUIDataTableToolbarSelect: {
      root: {
        backgroundColor: "#FAFAFA"
      }
    },
    MuiGridItem: {
      root: {

      }
    },
    MUIDataTableBodyCell: {
      root: {
        // backgroundColor: "#ff0000"
      },
      paper: {
        backgroundColor: "primary"
      }
    },
    MuiTableRow: {
      root: {
        verticalAlign: 'text-top'
      }
    },
    MUIDataTableFilter: {
      root: {
        backgroundColor: "#FAFAFA"
      }
    }
  }
};

const columns = [
  {
    name: "_id",
    label: "Id",
    options: {
      filter: false,
      sort: false,
      display: false
    },
  },
  {
    name: "physicalIssue",
    label: "Physical Issue",
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: "emotionalLink",
    label: "Emotional Link",
    options: {
      filter: false,
      sort: false
    }
  },
];

// eslint-disable-next-line
const validate = values => {
  const errors = {};

  const requiredFields = [
    'firstName',
    'lastName',
    'email',
    'role'
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  return errors
};

const renderFromHelper = ({touched, error}) => {
  if (!(touched && error)) {
    return
  } else {
    return <FormHelperText>{touched && error}</FormHelperText>
  }
};

class UserForm extends React.Component {

  tableOptions = {
    filterType: "checkbox",
    selectableRowsOnClick: true,
    onRowsDelete: (rowsDeleted) => {
      const idsToDelete = rowsDeleted.data.map(d => this.props.user.connections[d.dataIndex]._id); // array of all ids to to be deleted
      console.log("Deleting ids: ");
      console.log(idsToDelete);
      // http.delete(idsToDelete, res).then(window.alert('Deleted!')); // your delete request here
      // history.push(`/dashboard/admin/connections/edit/${rowData[0]}`);
      this.props.removeUserConnections(this.props.user._id, idsToDelete);
    },
    rowsPerPageOptions: [25, 50, 100],
    rowsPerPage: 100,
    responsive: "scrollMaxWidth",
    print: false,
    filter: false,
    download: false,
    search: false,
    viewColumns: false,
    pagination: false
  };

  renderError({error, touched}) {
    if (touched && error) {
      return (
        <div className="ui error message">
          <div className="header">{error}</div>
        </div>
      );
    }
  }

  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '1px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      variant="outlined"
      margine="normal"
      fullWidth
      {...input}
      {...custom}
    />
  );

  renderSelectField = ({
                         input,
                         label,
                         meta: {touched, error},
                         children,
                         ...custom
                       }) => (
    <FormControl error={touched && error}>
      <InputLabel htmlFor="role-native-simple">Role</InputLabel>
      <Select
        native
        {...input}
        {...custom}
        inputProps={{
          name: 'role',
          id: 'role-native-simple'
        }}
      >
        {children}
      </Select>
      {renderFromHelper({touched, error})}
    </FormControl>);

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };

  render() {
    const {classes} = this.props;
    return (
      <ThemeProvider theme={themeCustom}>
        <CssBaseline/>
        <Container className={classes.paper}
                   style={{
                     marginTop: "1px",
                     flex: "1 0 auto",
                     maxWidth: "auto"
                   }}>
          <Avatar className={classes.avatar}
                  style={{
                    color: "white",
                    backgroundColor:
                    theme.palette.primary.light
                  }}>
            <AccountCircleIcon fontSize="large"/>
          </Avatar>
          <Grid>
            <Container>
              <form
                onSubmit={this.props.handleSubmit(this.props.onSubmit)}
                className={classes.form}
                noValidate
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Field
                      name="firstName"
                      component={this.renderTextField}
                      label="First Name"
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      name="lastName"
                      component={this.renderTextField}
                      label="Last Name"
                      required/>
                  </Grid>
                  <Grid item xs={12}>
                    <Field name="email" component={this.renderTextField} label="Email: "/>
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      classes={classes}
                      name="role"
                      id="role"
                      component={this.renderSelectField}
                      label="Role"
                    >
                      <option value={'user'}>User</option>
                      <option value={'admin'}>Admin</option>
                    </Field>
                  </Grid>
                  <Grid item xs={12}>
                    <MUIDataTable
                      title="Users connections"
                      data={this.props.user.connections}
                      columns={columns}
                      options={this.tableOptions}
                    />
                  </Grid>
                  <Grid container justify="center" style={{marginTop: '16px'}}>
                    <Button type="submit" variant="contained" color="primary" fullWidth>Submit</Button>
                  </Grid>
                  <Grid container justify="center" style={{marginTop: '16px'}}>
                    <Button variant="contained"
                            color="secondary"
                            fullWidth
                            component={RouterLink}
                            to={`/dashboard/admin/users/delete/${this.props.initialValues._id}`}
                    >
                      Delete
                    </Button>
                  </Grid>
                  <Grid container justify="center" style={{marginTop: '16px'}}>
                    <Button variant="contained"
                            color="grey"
                            fullWidth
                            component={RouterLink}
                            to="/dashboard/admin/users"
                    >Cancel</Button>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </Grid>
        </Container>
      </ThemeProvider>
    );
  }
}

UserForm = withStyles(styles, {withTheme: true})(UserForm);

export default reduxForm({
  form: 'userForm',
  validate
})(UserForm);

